import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { FiArrowDownLeft } from 'react-icons/fi';
import useFetchData from '../../../hooks/useFetchData';

const ThisMonthIncomes = () => {
    const { items: incomes } = useFetchData("https://servers.thakurgaonexpress.com/rupkotha/getthismonthincomes");
    const TotalIncomes = (Array.isArray(incomes) ? incomes : []).reduce((total, currentValue) => total + (Number(currentValue?.amount) || 0), 0);


    return (
        // <div class="mx-auto w-11/12 bg-coral text-textPrimary rounded-lg overflow-hidden bg-[#E7FCE9] shadow-lg glassmorphism p-5">
       <div class="modern-card p-5">
            <div className='flex justify-between items-center'>
                <div class="flex flex-col justify-center items-center">
                    <div class="text-sm font-semibold mb-2">This Month Incomes</div>
                    <p class="text-xl text-textPrimary">৳ {TotalIncomes.toFixed(2)}</p>
                </div>
                <div className="dashboard-stat-card__icon"><FiArrowDownLeft /></div>
            </div>
        </div>
    );
};

export default ThisMonthIncomes;
